import { render, staticRenderFns } from "./PhoneButtons.vue?vue&type=template&id=8abb727e"
import script from "./PhoneButtons.vue?vue&type=script&lang=js"
export * from "./PhoneButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports